import * as d3 from 'd3'

export default {
  methods: {

    // call_NewWorkOrder
    call_NewWorkOrder(selection) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', ()=> {
        d3.select(`#NEW_WO`).transition().duration(75).style('opacity', .5)
      })
      .on('mouseout', ()=> {
        d3.select(`#NEW_WO`).transition().duration(250).style('opacity', 1)
      })
      .on('click', ()=> {
        let request_ = {
          action: {
            type: 'direct',
            target: 'workorder',
            component: 'ServiceToDoList',
            id: '',
            no: ''
          },
          filters: { 
          },
          iFilters: {
            filterString : '',
            inputFilter  : ''
          }
        }
        this.$emit('request-action', request_)

      })
    },

    //call_Department
    call_Department(selection, _d) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).style('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).style('opacity', 1)
      })
      .on('click', ()=> {
         _d.checked = _d.checked ? false : true
        this.update_Toolbar()
        this.canvasGanttChart.remove()

        this.filterData()
        this.draw_Table()
      })
    },

    // Outstanding Work Orders / Overall Work Orders / Service This Week
    call_Filtering(selection, _d, _idx) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).style('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).style('opacity', 1)
      })
      .on('click', ()=> {
        this.toolBar.filtering.forEach((d,i)=> {
          if(i == _idx) d.checked = true 
          else d.checked = false
        })

        this.update_Toolbar()

        this.canvasGanttChart.remove()

        this.filterData()
        this.draw_Table()
      })
    },


    // call_TimePeriod
    call_TimePeriod(selection, _d, _idx) {
      
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).attr('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).attr('opacity', 1)
      })
      .on('click', ()=> {
        this.toolBar.timePeriod.forEach((d,i)=> {
          if(i == _idx) d.checked = true 
          else d.checked = false
        })

        this.update_Toolbar()
        
        d3.select(`#GROUP_GANTT`).remove()
        this.set_Timeline()

        this.canvasGantt = this.canvasForms
        .append('g')
        .attr('id', `GROUP_GANTT`)
        .attr('transform', `translate(0, 0)`)

        this.exec_ScheduleChart() 
      })
    },

    //open_MenuItem
    open_MenuItem(selection, _d) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', ()=> {
        d3.select(`#Rect_${_d.idx}`).transition().duration(75).style('opacity', .7)
        d3.selectAll(`.Navi_${_d.idx}`).attr('fill', '#44A9DF')
      })
      .on('mouseout', ()=> {
        d3.select(`#Rect_${_d.idx}`).transition().duration(75).style('opacity', 0)
        d3.selectAll(`.Navi_${_d.idx}`).attr('fill', '#333')
      })
      .on('click', ()=> {
        this.draw_Popup_Window('MenuItem', _d)
        console.log(_d)
      })
    },

    // open_WorkOrder
    open_WorkOrder(selection, _d, _item) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', (event)=> {
        event.stopPropagation()
        d3.select(`#Rect_${_item.idx}`).transition().duration(75).style('opacity', 0)
        d3.selectAll(`.Navi_${_item.idx}`).attr('fill', '#333')
        d3.select(`#IDX_${_d.IDX}`).transition().duration(75).style('opacity', .5)
      })
      .on('mouseout', (event)=> {
        event.stopPropagation()
        d3.select(`#Rect_${_item.idx}`).transition().duration(75).style('opacity', .7)
        d3.selectAll(`.Navi_${_item.idx}`).attr('fill', '#44A9DF')
        d3.select(`#IDX_${_d.IDX}`).transition().duration(250).style('opacity', 1)
      })
      .on('click', (event)=> {
        event.stopPropagation()
        this.draw_Popup_Window('WorkOrder', _d, _item)
      })
    },

  }
}